import {StepValidationError} from "../components/Navigation/MenuItem";

const useMenuNavigation = (props) => {
  const {
    currMenu, menuItems, setServiceInitialData, onboardingData, syncOnboardingData, setLoading, handleError,
    setCurrService, setMenu, setMissingFieldsData
  } = props;

  return async (menuUID, stepUID) => {
    let _targetMenu = menuItems.findIndex(menu => menu.uid === menuUID);
    const isBack = _targetMenu <= currMenu

    if (!isBack) {
      setLoading(true);
      try {
        const lastIndex = _targetMenu;
        let prevService;
        for (_targetMenu = currMenu; _targetMenu < lastIndex; _targetMenu++) {
          try {
            const service = menuItems[_targetMenu];
            if(currMenu !== _targetMenu){
              await setServiceInitialData(service, prevService, onboardingData);
              await service.__setQuestionnaire(onboardingData.onboarding_answers, true);
            }
            syncOnboardingData(await service.skipAllSteps());
            prevService = service;
          } catch (error){
            if (error instanceof StepValidationError) {
              stepUID = error.stepUID;
              break;
            } else {
              throw error;
            }
          }
        }
      } catch (error) {
        handleError(error);
        return;
      }
    }

    await setCurrService(_targetMenu, isBack, stepUID);
    setMenu(_targetMenu);
    setMissingFieldsData(undefined);
  };
}

export default useMenuNavigation;